import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { RoutePaths } from '../../../../enums/RoutePaths';
import { setDealsheetMvo } from '../../../../store/essential-ui/mvoUI/MvoUiSlice';
import { setOffersKeepUsersOnSamePage } from '../../../../store/essential-ui/offers/OffersSlice';

type BackButtonStyleProps = {
  marginLeft?: number;
  showMessage?: boolean;
  marginTop?: number;
};

const BackButton: FC<BackButtonStyleProps> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickHandle = () => {
    let flag = DisplayExitPrompt(ExitPromptAction.Check);
    if (!flag) {
      dispatch(setDealsheetMvo(1));
      dispatch(setOffersKeepUsersOnSamePage(true));
      navigate(RoutePaths.EssentialDashboard);
    }
  };

  return (
    <Wrapper
      onClick={onClickHandle}
      data-testid='back-button'
      marginLeft={props.marginLeft}
      marginTop={props.marginTop}
    >
      Back
    </Wrapper>
  );
};

const DisplayExitPrompt = (action: ExitPromptAction) => {
  if (localStorage.getItem('qualifiedIncentiveChange') == null) {
    localStorage.setItem('qualifiedIncentiveChange', JSON.stringify(false));
  }

  if (action == ExitPromptAction.Show) {
    localStorage.setItem('qualifiedIncentiveChange', JSON.stringify(true));
  } else if (action == ExitPromptAction.Check) {
    const strHasQualifiedIncentiveChange = localStorage.getItem('qualifiedIncentiveChange');
    const boolHasQualifiedIncentiveChange =
      strHasQualifiedIncentiveChange === 'false' ? false : true;

    if (boolHasQualifiedIncentiveChange) {
      const message =
        'You made changes to qualified incentives. Do you want to discard the changes?';

      // eslint-disable-next-line no-restricted-globals
      if (!confirm(message)) {
        return true;
      } else {
        localStorage.setItem('qualifiedIncentiveChange', JSON.stringify(false));
        return false;
      }
    }
  } else {
    localStorage.setItem('qualifiedIncentiveChange', JSON.stringify(false));
  }
};

enum ExitPromptAction {
  Show = 1,
  Hide = 2,
  Check = 3,
}

export default BackButton;

export const Wrapper = styled.button<BackButtonStyleProps>`
  background-color: ${(props) => props.theme.palette.dusty};
  font-size: ${(props) => props.theme.typography.h4}px;
  border-radius: 20px;
  border: none;
  padding: 3px 16px 3px 16px;
  margin-left: ${(props) => props.marginLeft ?? '10'}px;
  margin-top: ${(props) => props.marginTop ?? '16'}px;
  color: ${(props) => props.theme.palette.white};
  font-weight: ${(props) => props.theme.typography.fontWeights.bold};
  & :focus {
    outline: none;
  }
`;
